export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// C:/Dropbox/www/amcharts4dev/node_modules/d3-geo/src/identity.js
// module id = null
// module chunks = 